import Footer from "components/Footer";
import Header from "components/Header";
import MainTitle from "components/MainTitle";
import QuickDonate from "components/QuickDonate/QuickDonate";
import { useDispatch, useSelector } from "react-redux";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import { RootState } from "redux/rootReducer";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import { Spin } from "antd";
import { useEffect, useState } from "react";
import { humanitarainCasesActions } from "redux/actions/humanitarainCasesActions/humanitarainCasesActions";
import { useTranslation } from "react-i18next";
import SmsDonationPopup from "components/smsDonation/SmsDonationPopup";
import HumanitarianCasesCard from "./HumanitarianCasesCard";

const HumanitarianCases = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  useEffect(() => {
    dispatch(humanitarainCasesActions());
  }, [dispatch]);

  const { humanitarainCasesLoading, humanitarainCases } = useSelector(
    (state: RootState) => state.humanitarainCasesReducer
  );

  const [showSmsDonation, setShowSmsDonation] = useState<boolean[]>(
    new Array(humanitarainCases?.length).fill(false)
  );

  const handleSmsDonationToggle = (index: number) => {
    setShowSmsDonation((prev) => {
      const newState = [...prev];
      newState[index] = !newState[index];
      return newState;
    });
  };

  return (
    <>
      <Header />

      <main className="relative w-full">
        {/* quick donate */}
        <QuickDonate />

        {/* quick donate popup  */}
        {quickDonateStatus && <QuickDonatePopUp />}

        {/* main header section  */}
        <MainTitle title={t("Humanitarian Cases")} />

        {/* Humanitarian Cases */}
        {!humanitarainCases ? (
          <section className="mt-[80px] min-h-[300px] w-full flex items-center justify-center">
            <p
              className={`font-${
                i18n.language === "en" ? "Poppins" : "Almarai"
              } font-[700] text-[20px] lg:text-[32px] text-first_color`}
            >
              {t("No Humanitarian Cases For Now")}
            </p>
          </section>
        ) : (
          <Spin spinning={humanitarainCasesLoading}>
            <section className="mt-[80px] min-h-[300px] w-full">
              {/* projects card section  */}
              <Splide
                options={{
                  direction: `${
                    localStorage.getItem("dir") === "rtl" ? "rtl" : "ltr"
                  }`,
                  grag: "free",
                  arrows: true,
                  pagination: false,
                  width: "100%",
                  autoplay: true,
                  rewind: true,
                  perMove: 1,
                  easing: "ease-out",
                  speed: 1000,
                  interval: 4000,
                  pauseOnHover: false,
                  pauseOnFocus: true,
                  breakpoints: {
                    1920: { perPage: 3, gap: "20px" },
                    1600: { perPage: 3, gap: "20px" },
                    1200: { perPage: 2, gap: "20px" },
                    800: { perPage: 1, gap: "20px" },
                  },
                }}
                className="px-[30px] lg-px-[40px] 2xl:px-[100px] flex flex-wrap items-center justify-center gap-[20px] 2xl:gap-[60px]"
              >
                {humanitarainCases?.map((project: any, i: number) => {
                  return (
                    <SplideSlide
                      key={i}
                      style={{
                        minWidth: "270px",
                      }}
                      className="w-full flex items-center justify-center"
                    >
                      <Spin spinning={humanitarainCasesLoading}>
                        <HumanitarianCasesCard
                          data={project}
                          showSmsDonation={showSmsDonation[i]}
                          setShowSmsDonation={() => handleSmsDonationToggle(i)}
                        />
                      </Spin>
                    </SplideSlide>
                  );
                })}
              </Splide>

              {humanitarainCases?.map((project: any, i: number) => {
                return (
                  <div key={i}>
                    {showSmsDonation[i] && (
                      <SmsDonationPopup
                        project={humanitarainCases?.at(i)}
                        show={showSmsDonation?.at(i) ?? false}
                        setShow={() => handleSmsDonationToggle(i)}
                      />
                    )}
                  </div>
                );
              })}
            </section>
          </Spin>
        )}
      </main>

      <Footer />
    </>
  );
};

export default HumanitarianCases;
